import { useCallback, useEffect, useMemo, useState } from "react";
import "./pdfViewer.css";
//pdf related imports
import { pdfjs, Document, Page } from "react-pdf";
// Import the styles for the pdf viewer
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Button, Tooltip, Input } from "antd";
import { ReactComponent as ArrowRight } from "../../assets/arrow-right.svg";
import "pdfjs-dist/build/pdf.worker.min.mjs";

import {
  PlusOutlined,
  MinusOutlined,
  SearchOutlined,
  DownloadOutlined,
  UpOutlined,
  DownOutlined
} from "@ant-design/icons";
import { useDebounce } from "use-debounce";
import { usePdfTextSearch } from "./usePdfTextSearch";
import { sanitizeString } from "../../util/removeDashesFromString";
import "pdfjs-dist/build/pdf.worker.min.mjs";


const PdfViewer = props => {
  const url = props.fileUrl;
  const filename = props.fileName;

  const Search = (
    <Tooltip
      title="Search in pdf"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <SearchOutlined />
    </Tooltip>
  );
  const NextResult = (
    <Tooltip
      title="Next Result Page"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <DownOutlined />
    </Tooltip>
  );
  const PreviousResult = (
    <Tooltip
      title="Previous Result Page"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <UpOutlined />
    </Tooltip>
  );
  const NextPage = (
    <Tooltip
      title="Next Page"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <ArrowRight style={{ transform: "rotate(90deg)" }} />
    </Tooltip>
  );
  const PreviousPage = (
    <Tooltip
      title="Previous Page"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <ArrowRight style={{ transform: "rotate(270deg)" }} />
    </Tooltip>
  );
  const ZoomIn = (
    <Tooltip
      title="Zoom In"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <PlusOutlined />
    </Tooltip>
  );
  const ZoomOut = (
    <Tooltip
      title="Zoom Out"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <MinusOutlined />
    </Tooltip>
  );
  const DownloadFile = (
    <Tooltip
      title="Download"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <DownloadOutlined />
    </Tooltip>
  );
  const OpenFile = (
    <Tooltip
      title="Open in new tab"
      placement="bottom"
      overlayClassName="toolbar-tooltip"
    >
      <DownloadOutlined style={{ transform: "rotate(270deg)" }} />
    </Tooltip>
  );

  const [searchString, setSearchString] = useState("");
  const [debouncedSearchString] = useDebounce(searchString, 250);
  const [ocurranceInPage, setOccuranceInPage] = useState(0);

  const file = useMemo(() => ({ url }), [url]);

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1);
  const [currentResultPage, setCurrentResultPage] = useState(0);

  const searchResults = usePdfTextSearch(file, debouncedSearchString);

  function highlightPattern(text, pattern, resultIndex = 1) {
    if (!pattern) {
      return text;
    }
    // console.debug({ocurranceInPage})

    var regEx = new RegExp(pattern, "ig");

    return text.replace(regEx, value => {
      const color =
        ocurranceInPage + 1 === resultIndex
          ? " rgba(234, 157, 24, 0.3)"
          : "rgba(234, 199, 24, 0.3)";
      setOccuranceInPage(ocurranceInPage + 1);
      return `<span style="background: ${color};">${value}</span>`;
    });
  }

  function onDocumentLoadSuccess(pdf) {
    setNumPages(pdf?.numPages);
  }

  const textRenderer = useCallback(
    textItem => highlightPattern(textItem.str, debouncedSearchString),
    [debouncedSearchString]
  );

  useEffect(() => {
    if (searchResults?.length) {
      setPageNumber(searchResults[0]);
    }
  }, [searchResults]);

  useEffect(() => {
    setOccuranceInPage(0);
  }, [pageNumber, searchString]);

  return (
    <>
      <div id="pdf-toolbar">
        {numPages && (
          <>
            <div id="pdf-search">
              <Button
                id="pdf-search"
                shape="circle"
                type="link"
                icon={Search}
                className="pdf-page-button"
                // style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
              />
              <Input
                id="toolbar-search-input"
                placeholder="Search in pdf"
                onChange={e => setSearchString(sanitizeString(e.target.value))}
                size="small"
              />
              {searchString && true && (
                <>
                  <span id="pdf-matches-text">{`${
                    searchResults?.length ? `${currentResultPage + 1}/` : ""
                  }${searchResults?.length} pages with matches`}</span>
                  <Button
                    id="pdf-previous-result"
                    shape="circle"
                    type="link"
                    icon={PreviousResult}
                    className="pdf-page-button"
                    onClick={() => {
                      if (currentResultPage > 0) {
                        setPageNumber(searchResults[currentResultPage - 1]);
                        setCurrentResultPage(currentResultPage - 1);
                      }
                    }}
                    // style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
                  />
                  <Button
                    id="pdf-next-result"
                    shape="circle"
                    type="link"
                    icon={NextResult}
                    className="pdf-page-button"
                    onClick={() => {
                      if (
                        searchResults?.length &&
                        currentResultPage + 1 < searchResults?.length
                      ) {
                        setPageNumber(searchResults[currentResultPage + 1]);
                        setCurrentResultPage(currentResultPage + 1);
                      }
                    }}
                  />
                </>
              )}
            </div>{" "}
            <div id="pdf-zoom">
              <Button
                id="pdf-page-zoomout"
                shape="circle"
                type="link"
                icon={ZoomOut}
                className="pdf-page-button"
                onClick={() => {
                  if (zoom > 0.6) setZoom(zoom - 0.1);
                }}
                // style={{
                //   visibility:
                //     Math.round(zoom * 10) / 10 === 0.5 ? "hidden" : "visible"
                // }}
              />
              <Button
                id="pdf-page-zoomin"
                shape="circle"
                type="link"
                icon={ZoomIn}
                className="pdf-page-button"
                onClick={() => {
                  if (zoom < 1.7) setZoom(zoom + 0.1);
                }}
                // style={{
                //   visibility:
                //     Math.round(zoom * 10) / 10 === 1.7 ? "hidden" : "visible"
                // }}
              />
              <span>{`${Math.round(zoom * 100)}%`}</span>
            </div>
            <div id="pdf-pagination">
              <Button
                id="pdf-page-previous"
                shape="circle"
                type="link"
                icon={PreviousPage}
                className="pdf-page-button"
                onClick={() => {
                  if (pageNumber > 1) {
                    setPageNumber(pageNumber - 1);
                  }
                }}
                // style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
              />
              <Button
                id="pdf-page-next"
                shape="circle"
                type="link"
                icon={NextPage}
                className="pdf-page-button"
                onClick={() => {
                  if (pageNumber < numPages) {
                    setOccuranceInPage(0);
                    setPageNumber(pageNumber + 1);
                  }
                }}
                // style={{
                //   visibility: pageNumber === numPages ? "hidden" : "visible"
                // }}
              />{" "}
              <span>
                Page {numPages ? pageNumber : "-"} of {numPages || "-"}
              </span>
            </div>
            <div id="pdf-actions">
              <Button
                id="pdf-download"
                shape="circle"
                type="link"
                icon={DownloadFile}
                className="pdf-page-button"
                onClick={() => {
                  const downloadLink = document.createElement("a");
                  downloadLink.href = url;
                  downloadLink.download = filename; //without this it just opens it in browser instead of downloading it
                  document.body.appendChild(downloadLink); // Required for Firefox
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                }}
                // style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
              />
              <Button
                id="pdf-open"
                shape="circle"
                type="link"
                icon={OpenFile}
                className="pdf-page-button"
                onClick={() => {
                  const downloadLink = document.createElement("a");
                  downloadLink.href = url;
                  downloadLink.target = "_blank";
                  document.body.appendChild(downloadLink); // Required for Firefox
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                }}
                // style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
              />
            </div>
          </>
        )}
      </div>
      <div
        id="pdf-wrapper"
        style={{
          //   border: "0.063rem solid rgba(0, 0, 0, 1)",
          boxShadow: "0rem 0.25rem 1.75rem rgba(217.94, 198.4, 245.44",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "auto",
          width: "min-content"
        }}
      >
        {/* <iframe src={url} title="Blob" width='1000' height='1000'></iframe> */}
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page
            key={`page_${pageNumber}`}
            pageNumber={pageNumber}
            scale={zoom}
            customTextRenderer={textRenderer}
          />
        </Document>
      </div>
    </>
  );
};

export default PdfViewer;
